import React from 'react';

// eslint-disable-next-line @atlaskit/design-system/no-emotion-primitives -- to be migrated to @atlaskit/primitives/compiled – go/akcss
import { Anchor, Inline, Box, xcss } from '@atlaskit/primitives';

import { useSpaceKey } from '@confluence/space-utils/entry-points/useSpaceKey.ts';
import { PAGE_ANALYTICS } from '@confluence/named-routes/entry-points/routes.ts';

const containerStyles = xcss({
	width: '100%',
});

const AnchorStyles = xcss({
	width: '100%',
	textAlign: 'center',
	textDecoration: 'none',
	':hover': {
		textDecoration: 'none',
	},
});

const ViewMoreButtonStyles = xcss({
	width: '100%',
	height: '32px',
	borderRadius: 'radius.xsmall',
	textDecoration: 'none',
	backgroundColor: 'color.background.neutral',
	color: 'color.text',
	fontWeight: 'font.weight.medium',
	':hover': {
		backgroundColor: 'color.background.neutral.hovered',
	},
	':active': {
		backgroundColor: 'color.background.neutral.pressed',
	},
});

export type ContentAnalyticsLinkProps = React.PropsWithChildren<{
	contentId?: string;
	contentTab?: 'Overview' | 'Mentions' | 'Links';
	testId?: string;
	onClick?: () => void;
}>;

export const ContentAnalyticsLink = ({
	contentId,
	contentTab,
	onClick,
	testId,
	children,
}: ContentAnalyticsLinkProps) => {
	const spaceKey = useSpaceKey() || ``;

	// spaceKey and contentId are required for PAGE_ANALYTICS.toUrl
	if (!spaceKey || !contentId) {
		return null;
	}

	const pageAnalyticsURL = PAGE_ANALYTICS.toUrl({
		spaceKey,
		contentId,
		tab: contentTab ? contentTab.toLowerCase() : undefined,
	});

	return (
		<Box paddingBlockStart="space.200" xcss={containerStyles}>
			<Anchor href={pageAnalyticsURL} onClick={onClick} testId={testId} xcss={AnchorStyles}>
				<Inline xcss={ViewMoreButtonStyles} alignInline="center" alignBlock="center">
					{children}
				</Inline>
			</Anchor>
		</Box>
	);
};
